import React from "react";
import { NewFeatureHighlightLocal } from "components/NewFeature/NewFeatureHighlightLocal";
import { AnchorButton } from "components/Button/AnchorButton";
import { useTeamsAnnouncement } from "./hooks/useTeamsAnnouncement";
import { BLOG_POST_LINK } from "./constants";
import dashboardSchedule from "./assets/create-dashboard-schedule.png";
import querySchedule from "./assets/create-query-schedule.png";
import createFolders from "./assets/create-folders.png";
import dataUpload from "./assets/data-upload.png";

export const ScheduleQueryFeatureHighlight = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  if (!useTeamsAnnouncement()) {
    return <>{children}</>;
  }

  return (
    <NewFeatureHighlightLocal
      position="above-align-right"
      title="Schedule your query runs"
      description="Get the most up-to-date data when you need it."
      feature="crete-query-schedule"
      imgSrc={querySchedule.src}
      actions={
        <>
          <AnchorButton
            size="M"
            theme="tertiary"
            href={BLOG_POST_LINK}
            target="_blank"
          >
            Learn more
          </AnchorButton>
        </>
      }
    >
      <>{children}</>
    </NewFeatureHighlightLocal>
  );
};

export const ScheduleDashboardFeatureHighlight = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  if (!useTeamsAnnouncement()) {
    return <>{children}</>;
  }

  return (
    <NewFeatureHighlightLocal
      position="below-align-right"
      title="Schedule your dashboard runs"
      description="Optimize for efficiency and data freshness by scheduling dashboards."
      feature="crete-dashboard-schedule"
      imgSrc={dashboardSchedule.src}
      actions={
        <>
          <AnchorButton
            size="M"
            theme="tertiary"
            href={BLOG_POST_LINK}
            target="_blank"
          >
            Learn more
          </AnchorButton>
        </>
      }
    >
      <>{children}</>
    </NewFeatureHighlightLocal>
  );
};

export const FolderFeatureHighlight = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  if (!useTeamsAnnouncement()) {
    return <>{children}</>;
  }

  return (
    <NewFeatureHighlightLocal
      position="below-align-right"
      title="Create a folder"
      description="Organize content for better organization and collaboration between team users."
      feature="crete-folders"
      imgSrc={createFolders.src}
      actions={
        <>
          <AnchorButton
            size="M"
            theme="tertiary"
            href={BLOG_POST_LINK}
            target="_blank"
          >
            Learn more
          </AnchorButton>
        </>
      }
    >
      <>{children}</>
    </NewFeatureHighlightLocal>
  );
};

export const DataUploadFeatureHighlight = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  if (!useTeamsAnnouncement()) {
    return <>{children}</>;
  }

  return (
    <NewFeatureHighlightLocal
      position="below-align-left"
      title="Upload your data"
      description="Integrate your off-chain data with Dune’s data for rich context and insights."
      feature="data-upload"
      imgSrc={dataUpload.src}
      actions={
        <>
          <AnchorButton
            size="M"
            theme="tertiary"
            href={BLOG_POST_LINK}
            target="_blank"
          >
            Learn more
          </AnchorButton>
        </>
      }
    >
      <>{children}</>
    </NewFeatureHighlightLocal>
  );
};
